// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yp85L","largestCol":"styles_largestCol__gcgtl","smallestCol":"styles_smallestCol__3fWF0"};